import { ContactGroup } from "@/Apps/CRM/widgets/ContactGroup";
import { ContactWidgetProps } from "@/Apps/CRM/widgets/types";

export const ScrollStatus: React.FC<ContactWidgetProps> = ({ id }) => {
  const statusFields = ["scrollReceived", "inQueue", "scrollSent"];
  return <ContactGroup id={id} title="Scroll Status" fields={statusFields} />;
};
